import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
import { NotificationOrderStatusCheckbox } from '../notification-orderStatus-checkbox';
export const OrderStatusCheckboxList = ({ orderStatusList, handlecheckbox, orderStatusValue }) => {
    return (_jsx(_Fragment, { children: Object.keys(orderStatusList).map((title) => {
            return (_jsxs("div", { children: [_jsx(CatHeading, { variant: "title-sm", level: "h6", "data-testid": "notification-preference-heading-md", children: title }), _jsx("div", { className: "mt-2 ms-2", children: orderStatusList[title].map((row) => {
                            return (_jsx("div", { children: _jsx(NotificationOrderStatusCheckbox, { label: row.label, handleChange: handlecheckbox, value: row, orderStatusValue: orderStatusValue }) }, row.label));
                        }) })] }, title));
        }) }));
};
